<template>
<div class="container" >
  <router-view></router-view>
</div>

</template>

<script>
export default {
  name: 'AppMain',
}
</script>

<style scoped>
.container{
  width: 100%;
}
@media (max-width: 768px) {
}
@media (min-width: 769px) {
  .container {
  min-height: calc(100vh - 200px);
}
}

</style>